import React, { useState, useEffect } from "react";
import { Tabs, Descriptions } from "antd";
import { Container, Col, Row } from "react-bootstrap";
import Common from "./includes/Common";
import NewPrescription from "./forms/NewPrescription";
import { EyeFill, SlashSquareFill, Tools, BandaidFill, Eyedropper, FileBreak, ImageFill, MagnetFill, Broadcast } from "react-bootstrap-icons";
import NewPharmacyPrescription from "./forms/NewPharmacyPrescription";
import NewGlassPrescription from "./forms/NewGlassPrescription";
import NewChirurgyPrescription from "./forms/NewChirurgyPrescription";
import NewLaserPrescription from "./forms/NewLaserPrescription";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";

var Prescriptions = function Prescriptions(_ref) {
  var _ref$patient = _ref.patient,
      patient = _ref$patient === void 0 ? null : _ref$patient,
      _ref$check = _ref.check,
      check = _ref$check === void 0 ? null : _ref$check,
      handler = _ref.handler;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 3,
          md: 3,
          children: /*#__PURE__*/_jsxs("div", {
            className: "cool-radius",
            style: {
              background: '#FD8363',
              color: "#EEE"
            },
            children: [/*#__PURE__*/_jsx("h4", {
              children: /*#__PURE__*/_jsx("b", {
                children: "MOTIF"
              })
            }), check.reason.substring(0, 196), " ..."]
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 9,
          md: 9,
          children: /*#__PURE__*/_jsxs(Tabs, {
            animated: true,
            defaultActiveKey: 1,
            children: [/*#__PURE__*/_jsx(Tabs.TabPane, {
              tab: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(MagnetFill, {
                  size: 30
                }), " IRM"]
              }),
              children: /*#__PURE__*/_jsx(NewPrescription, {
                dcode: "IRM",
                patient: patient,
                check: check,
                handler: handler
              })
            }, 1), /*#__PURE__*/_jsx(Tabs.TabPane, {
              tab: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(FileBreak, {
                  size: 30
                }), " SCANNER"]
              }),
              children: /*#__PURE__*/_jsx(NewPrescription, {
                dcode: "SCA",
                patient: patient,
                check: check,
                handler: handler
              })
            }, 2), /*#__PURE__*/_jsx(Tabs.TabPane, {
              tab: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(Broadcast, {
                  size: 30
                }), " RADIOGRAPHIE"]
              }),
              children: /*#__PURE__*/_jsx(NewPrescription, {
                dcode: "RAD",
                patient: patient,
                check: check,
                handler: handler
              })
            }, 3), /*#__PURE__*/_jsx(Tabs.TabPane, {
              tab: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(ImageFill, {
                  size: 30
                }), " ECHOGRAPHIE"]
              }),
              children: /*#__PURE__*/_jsx(NewPrescription, {
                dcode: "ECHO",
                patient: patient,
                check: check,
                handler: handler
              })
            }, 4), /*#__PURE__*/_jsx(Tabs.TabPane, {
              tab: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(Eyedropper, {
                  size: 30
                }), " LABORATOIRE"]
              }),
              children: /*#__PURE__*/_jsx(NewPrescription, {
                dcode: "LAB",
                patient: patient,
                check: check,
                handler: handler
              })
            }, 5)]
          })
        })]
      })
    })
  });
};

export default Prescriptions;